<template>
  <div class="cursor-pointer p-2 z-20" @click="menu = !menu">
    <img src="../assets/top/menu.png"  width="31" />
  </div>
  <transition name="fade">
    <div v-show="menu" class="menu">
      <div class="absolute top-[16px] md:top-[1.6rem] right-[12px] md:right-6 cursor-pointer p-2 z-20" @click="menu = !menu">
        <img src="../assets/common/close.svg"  width="31" />
      </div>
      <div class="md:flex">
        <ul class="md:text-right main-menu">
          <li><a href="/">HOME</a></li>
          <li><a href="/about">ゆずりはについて</a></li>
          <li><a href="/philosophy">ゆずりはの理念</a></li>
          <li><a href="/action">ゆずりはの活動</a></li>
          <li><a href="https://congrant.com/project/yuzuriha/7907" target="_blank">ゆずりは運営費への寄付</a>
            <ul>
              <li><a href="/donation/">その他の支援方法</a></li>
              <li><a href="/donation/deduction">寄付に関する税制控除について</a></li>
            </ul>
          </li>
        </ul>        
        <div class="flex flex-col justify-center">
          <ul class="sub-menu">
            <li><a href="/news">お知らせ</a></li>
            <li><a href="/contact">お問い合わせ</a></li>
            <li><a href="https://goo.gl/maps/7FjZffdCYCAQcwqJ8" target="_blank">グーグルマップ</a></li>
            <li><a href="/privacy">個人情報保護方針</a></li>
          </ul>
          <ul class="flex items-center mt-12 md:mt-6 sns">
            <li><a href="https://www.instagram.com/acyuzuriha/" target="_blank"><img src="../assets/common/icon-insta.svg"></a></li>
            <li><a href="https://www.facebook.com/acyuzuriha/" target="_blank"><img src="../assets/common/icon-fb.svg"></a></li>
            <li>
              <a class="hover:underline text-xs tracking-wide flex items-center font-bold"
                 href="https://yuzuriha.theshop.jp/" target="_blank"><img class="mr-2" width="15"
                                                                          src="../assets/common/icon-store.png"/>ゆずりはのジャム</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Menu",
  data() {
    return {
      menu: false,
    }
  }
}
</script>

<style lang="scss" scoped>

.menu {
  width: 100%;
  height: 100vh;
  background: rgba(#fff, 0.9);
  @apply flex md:items-center justify-center pt-16 md:pt-0 z-20 fixed top-0 left-0;
}

a {
  @apply hover:opacity-75;
}

.main-menu {
  @apply border-b-2 md:border-b-0 md:border-r-2 border-white pb-8 md:mb-8 md:pb-0 md:mb-0 md:pr-12 md:mr-12 space-y-4;

    li {
      letter-spacing: 0.05em;
      @apply text-15 font-medium;

      ul {
        @apply space-y-2 mt-3;

        li {
          @apply text-xs;

          a {
            color: #666666;
          }

          @media screen and (max-width: 640px) {
            @apply pl-1;

            &:before {
              content: '-';
              margin-right: 0.8em;
            }
          }

          @media screen and (min-width: 640px) {
            &:after {
              content: '-';
              margin-left: 0.8em;
            }
          }

        }
      }
    }
}

.sub-menu {
  @apply text-13 space-y-3 md:space-y-4;
}

.sns {
  li:nth-child(2) {
    margin-left: 8px;
    margin-right: 10px;

  }
}

</style>